import gql from "graphql-tag";

const queryCreateDocumentConfig = gql`
  mutation($title: String!, $usersIds: [ID!]!) {
    createDocumentConfig(data: { title: $title, usersIds: $usersIds }) {
      id
      title
      users {
        id
        fullname
        email
      }
      updatedAt
      createdAt
    }
  }
`;

const queryUpdateDocumentConfig = gql`
  mutation($title: String, $usersIds: [ID!]!, $id: ID!) {
    updateDocumentConfig(
      id: $id
      data: { title: $title, usersIds: $usersIds }
    ) {
      id
      title
      users {
        id
        fullname
        email
      }
      updatedAt
      createdAt
    }
  }
`;

const queryDeleteDocumentConfig = gql`
  mutation($id: ID!) {
    deleteDocumentConfig(id: $id) {
      id
    }
  }
`;

export default {
  queryCreateDocumentConfig,
  queryUpdateDocumentConfig,
  queryDeleteDocumentConfig,
};
